export default __webpack_public_path__ + "static/media/04.db7255fa.jpg";